import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../data/content";
import { stagger, viewport, EASE } from "../lib/motion";
import PageHero from "../components/PageHero";
import ServiceIcon from "../components/ServiceIcon";

export default function ServicesIndex() {
  return (
    <div data-testid="services-page">
      <PageHero
        overline="Our Services"
        title="Services"
        subtitle="Six specialised verticals under one roof - engineered with machines, run on process, and delivered by trained, supervised teams."
      />

      <motion.section
        variants={stagger}
        initial="hidden"
        animate="show"
        className="mx-auto max-w-[1400px] px-5 py-20 md:px-10 md:py-28"
      >
        <div className="grid gap-6 lg:grid-cols-2">
          {SERVICES.map((s) => (
            <motion.div
              key={s.id}
              variants={{ hidden: { opacity: 0, y: 30 }, show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: EASE } } }}
            >
              <Link
                to={`/services/${s.id}`}
                data-testid={`service-item-${s.id}`}
                className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-[#0a0a0a]"
              >
                <div className="relative aspect-[16/9] overflow-hidden">
                  <img src={s.image} alt={s.title} className="h-full w-full object-cover grayscale transition-all duration-700 group-hover:grayscale-0 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent" />
                  <span className="absolute right-5 top-5 flex h-11 w-11 items-center justify-center rounded-full bg-black/50 backdrop-blur text-accent">
                    <ServiceIcon name={s.icon} size={20} />
                  </span>
                  <span className="font-display absolute left-5 top-4 text-5xl font-black text-white/20">{s.index}</span>
                </div>
                <div className="flex flex-1 flex-col p-7">
                  <h3 className="font-display text-2xl md:text-3xl font-bold tracking-tight">{s.title}</h3>
                  <p className="mt-2 text-xs uppercase tracking-[0.15em] text-accent font-semibold">{s.tagline}</p>
                  <p className="mt-4 flex-1 text-sm text-neutral-400 leading-relaxed">{s.overview}</p>
                  <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-white group-hover:text-accent transition-colors">
                    Explore {s.title.split(" ")[0]} <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </motion.section>
    </div>
  );
}
